export default "/fonts/fa-v4compatibility.ttf?e314b618134d5be20996d79e7245160b";